// The clinic's contact email for patient-facing message text built in the
// browser ("For questions, email ...", "To opt out ... email ...").
//
// The backend reads it from its env (backend/api/clinic_contact.py). The
// browser can't see that env, so it uses the clinic's ZOHO_EMAIL setting from
// public.schema_settings, which is kept equal to the backend's ZOHO_EMAIL
// (sql/migrations/2026-10-19-zoho-sender-switch.sql). Templates write
// {contact_email} instead of a hard-coded address.

export const clinicContactEmail = (settings) =>
  String(settings?.ZOHO_EMAIL || "").trim();

export const fillContactEmail = (text, settings) =>
  String(text).split("{contact_email}").join(clinicContactEmail(settings));
